window.addEventListener('load', function () {
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-ugc-trigger]');
    const closeBtn = event.target.closest('[data-ugc-close]');

    if (trigger) {
      const section = trigger.closest('.ugc-video-section');
      if (!section) return;

      const modal = section.querySelector('.ugc-modal');
      const holder = section.querySelector('[data-ugc-video-holder]');
      if (!modal || !holder) return;

      let video = holder.querySelector('video');

      if (!video) {
        video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';

        if (holder.dataset.videoPoster) {
          video.poster = holder.dataset.videoPoster;
        }

        if (holder.dataset.videoUrl) {
          video.src = holder.dataset.videoUrl;
        }

        holder.appendChild(video);
        video.load();
      }

      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');

      return;
    }

    if (closeBtn) {
      const modal = closeBtn.closest('.ugc-modal');
      if (!modal) return;

      const section = modal.closest('.ugc-video-section');
      const triggerEl = section ? section.querySelector('[data-ugc-trigger]') : null;
      const holder = modal.querySelector('[data-ugc-video-holder]');
      const video = holder ? holder.querySelector('video') : null;

      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');

      if (triggerEl) {
        triggerEl.setAttribute('aria-expanded', 'false');
      }

      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.remove();
      }
    }
  });
});